import { DashboardUsers } from '../../models';
import { IDispatcherService, IDispatcher, Dispatcher } from '../';
import { IDashboardUserActionsService } from './dashboardUsers.actionCreator';

export interface IDashboardUserStoreService {
    getAll(): Dispatcher<DashboardUsers>;
    getAll(force: boolean): Dispatcher<DashboardUsers>;
}

export interface IDashboardUserActionsDispatcherService extends IDispatcherService<IDashboardUserStoreService> { }

export class DashboardUserActionsDispatcherService implements IDashboardUserActionsDispatcherService {
    static serviceId = 'dashboardUserActionsDispatcherService';

    static $inject = ['dashboardUserActionsService'];

    constructor(private _actionService: IDashboardUserActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IDashboardUserStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force))
            }
        };
    }
}